import React, { useEffect, useState } from "react";
import {
  Grid,
  Checkbox,
  Radio,
  FormControl,
  Select,
  MenuItem,
  ListItemText,
} from "@material-ui/core";
import CustomTextField from "../Common/CustomTextField";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { useSelector } from "react-redux";

function AddNewUserFromNodes(props) {
  const {
    user = {},
    setUser = () => { },
    allAccess = [],
    parentUser = {},
    isSuperAdminLogin = false,
  } = props;
  const {
    firstName = "",
    lastName = "",
    email = "",
    forwardEmail = "",
    dateOfBirth = "",
    premiumAccessExpiry,
    password = "",
    role = [],
  } = user || {};
  const [modules, setModules] = useState([]);
  const [allRoles, setAllRoles] = useState([
    { id: 1, name: "User", value: "user" },
  ]);
  const { allOrganization = [] } = useSelector((state) => state.dashboard);

  useEffect(() => {
    if (parentUser.role === "head") {
      setAllRoles([{ id: 1, name: "User", value: "user" }]);
      setModules(parentUser.moduleAccess);
    } else if (parentUser.role === "superboss") {
      setAllRoles([
        { id: 1, name: "User", value: "user" },
        { id: 2, name: "Head", value: "head" },
      ]);
      setModules(["chartering", "operations", "accounts", "agency", "shipmanagament", "admin", "riskmanagement", "fuelsupply"]);
    }
  }, [parentUser]);

  const onChange = (key, value) => {
    setUser((prevUser) => {
      if (key === "role") {
        const newModuleAccess = value === "superboss" ? modules : [];

        const newModuleHeads =
          value === "head" || value === "superboss"
            ? {}
            : modules.reduce((acc, module) => {
              if (newModuleAccess.includes(module)) {
                acc[module] = prevUser.moduleHeads?.[module] || [
                  {
                    _id: parentUser._id,
                    firstName: parentUser.firstName,
                    lastName: parentUser.lastName,
                  },
                ];
              }
              return acc;
            }, {});

        return {
          ...prevUser,
          role: value,
          moduleAccess: newModuleAccess,
          moduleHeads: newModuleHeads,
        };
      }

      if (key === "moduleAccess" && prevUser.role !== "head") {
        const updatedModuleAccess = value;
        const updatedModuleHeads = Object.keys(
          prevUser.moduleHeads || {}
        ).reduce((acc, module) => {
          if (updatedModuleAccess.includes(module)) {
            acc[module] = prevUser.moduleHeads[module];
          }
          return acc;
        }, {});

        updatedModuleAccess.forEach((module) => {
          if (!updatedModuleHeads[module]) {
            updatedModuleHeads[module] = [
              {
                _id: parentUser._id,
                firstName: parentUser.firstName,
                lastName: parentUser.lastName,
              },
            ];
          }
        });

        return {
          ...prevUser,
          moduleAccess: updatedModuleAccess,
          moduleHeads: updatedModuleHeads,
        };
      }

      return {
        ...prevUser,
        [key]: value,
      };
    });
  };

  return (
    <Grid container spacing={2} className="p-2">
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label="First Name"
          placeholder="First Name"
          value={firstName}
          onChange={(e) => onChange("firstName", e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label="Last Name"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => onChange("lastName", e.target.value)}
        />
      </Grid>
      {/* add to disable chrome auto fill */}
      <Grid item xs={12}>
        <CustomTextField
          label="Email"
          placeholder="Email"
          value={email}
          onChange={(e) => onChange("email", e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomTextField
          label="Forward mail address"
          placeholder="Email address"
          value={forwardEmail}
          onChange={(e) => onChange("forwardEmail", e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <KeyboardDatePicker
            autoOk
            fullWidth
            variant="inline"
            inputVariant="outlined"
            format="DD/MMM/yyyy"
            placeholder="DOB: DD/MMM/YYYY"
            label="Date Of Birth"
            value={dateOfBirth || null}
            InputAdornmentProps={{ position: "end" }}
            onChange={(date) => onChange("dateOfBirth", date)}
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid item xs={12} sm={6}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <KeyboardDatePicker
            autoOk
            fullWidth
            variant="inline"
            inputVariant="outlined"
            format="DD/MMM/yyyy"
            label="Premium Access Expiry Date"
            placeholder="Premium Access Expiry Date"
            value={premiumAccessExpiry || null}
            InputAdornmentProps={{ position: "end" }}
            onChange={(date) => onChange("premiumAccessExpiry", date)}
          />
        </MuiPickersUtilsProvider>
      </Grid>
      {/* add to disable chrome auto fill */}
      <Grid item xs={12} sm={6} style={{ display: "none" }}>
        <CustomTextField />
      </Grid>
      <Grid item xs={12}>
        <CustomTextField
          inputType="password"
          placeholder="Password"
          value={password}
          onChange={(e) => onChange("password", e.target.value)}
        />
      </Grid>

      {user.role !== "superadmin" && isSuperAdminLogin && (
        <Grid item xs={4}>
          <h4>Select Roles</h4>
          <ul className="select-roles-list">
            {Array.isArray(allRoles) &&
              allRoles.map((item, index) => {
                const isSelected = role === item.value;
                return (
                  <li
                    style={{ cursor: "pointer" }}
                    key={index}
                    onClick={() => onChange("role", item.value)}
                  >
                    <Radio checked={!!isSelected} />
                    {item.name}
                  </li>
                );
              })}
          </ul>
        </Grid>
      )}

      <Grid item xs={8}>
        <Grid container>
          {user.role !== "superboss" && (
            <Grid item xs={12}>
              <h4>Select Organization</h4>
              <ul className="select-roles-list">
                <CustomTextField
                  disabled
                  size="small"
                  value={
                    allOrganization.find(
                      (org) => org._id === user.organizationId
                    )?.organizationName
                  }
                />
              </ul>
            </Grid>
          )}
          <Grid item xs={12} className="mt-4">
            <h4>Select Module Access</h4>

            <ul className="select-roles-list">
              <FormControl variant="filled" size="small" fullWidth>
                <Select
                  multiple
                  value={user.moduleAccess || []}
                  onChange={(e) => onChange("moduleAccess", e.target.value)}
                  renderValue={(selected) => selected.join(", ")}
                  className="bg-white rounded-md capitalize"
                  size="small"
                  variant="outlined"
                  fullWidth
                >
                  {modules.map((module) => (
                    <MenuItem key={module} value={module}>
                      <Checkbox
                        checked={user.moduleAccess?.includes(module)}
                        color="primary"
                      />
                      <ListItemText
                        primary={
                          module.charAt(0).toUpperCase() + module.slice(1)
                        }
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </ul>
          </Grid>
          {user.role === "user" && user.organizationId && (
            <Grid item xs={12} className="mt-4">
              {user.moduleAccess?.map((module) => (
                <Grid item xs={12} key={module}>
                  <h4>
                    {module.replace(/\b\w/g, (l) => l.toUpperCase())} Head
                  </h4>
                  <ul className="select-roles-list">
                    <CustomTextField
                      disabled
                      size="small"
                      value={user.moduleHeads[module]
                        .map(
                          (head) => `${head.firstName} (${parentUser.email})`
                        )
                        .join(", ")}
                    />
                  </ul>
                </Grid>
              ))}
            </Grid>
          )}
          {user.role !== "superadmin" && (
            <Grid item xs={12} className="mt-2">
              <h4>User Access</h4>{" "}
              <ul className="select-roles-list flex">
                {Array.isArray(allAccess) &&
                  allAccess.map((item, index) => {
                    return (
                      <li
                        style={{ cursor: "pointer" }}
                        key={index}
                        onClick={() => onChange(item.value, !user[item.value])}
                      >
                        <Checkbox checked={user[item.value]} />
                        {item.name}
                      </li>
                    );
                  })}
              </ul>
            </Grid>
          )}
        </Grid>
      </Grid>
      {user.role === "superboss" && (
        <textarea
          className="w-full border border-gray-300 rounded-md p-2 resize-none"
          rows={2}
          type=""
          value={user.description || ""}
          onChange={(e) => onChange("description", e.target.value)}
          placeholder="add description here"
        ></textarea>
      )}
    </Grid>
  );
}

export default AddNewUserFromNodes;
